import { render } from "./FooterBrand.vue?vue&type=template&id=3a101174&scoped=true"
import script from "./FooterBrand.vue?vue&type=script&lang=js"
export * from "./FooterBrand.vue?vue&type=script&lang=js"

import "./FooterBrand.vue?vue&type=style&index=0&id=3a101174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a101174"]])

export default __exports__